import Menu, { MenuProps } from "@mui/material/Menu";
import styled from "@mui/material/styles/styled";

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: theme.corners.base,
  },
  "& .MuiList-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDivider-root": {
    margin: "4px 0 !important",
  },
}));

const SideNavMenu = (props: MenuProps) => (
  <StyledMenu
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "bottom", horizontal: "left" }}
    marginThreshold={0}
    {...props}
  />
);

export default SideNavMenu;
